import { MarqueeText } from '../../../shared/components/MarqueeText.jsx';
import { NikkeBurstGlyph } from '../../nikke-icons/shared/NikkeBurstGlyph.jsx';
import { NikkeIcon } from '../../nikke-icons/shared/NikkeIcon.jsx';
import { findNikkeInCatalog } from '../domain/nikkeCatalog.js';
import { ElementIcon } from './ElementIcon.jsx';
import { NikkePortraitImage } from './NikkePortraitImage.jsx';

const text = (value) => String(value ?? '').trim();

function burstRoman(item) {
  const value = String(item?.burst || item?.burstCode || '').trim();
  if (value === '1' || value === 'Step1') return 'I';
  if (value === '2' || value === 'Step2') return 'II';
  if (value === '3' || value === 'Step3') return 'III';
  if (value === 'A' || value === 'AllStep') return 'A';
  return '-';
}

export function NikkeDeckDisplay({
  deck = [],
  mobile = false,
  catalog = null,
  loading = 'lazy',
  fetchPriority = 'auto',
  lightweight = false,
}) {
  const prefix = mobile ? 'mobile' : 'desktop';
  const codes = (Array.isArray(deck) ? deck : []).map(text).filter(Boolean).slice(0, 5);
  if (!codes.length) return <small>덱 정보 없음</small>;

  return (
    <div className={`${prefix}-raid-practice-deck-display`}>
      {codes.map((code, index) => {
        const item = findNikkeInCatalog(catalog, code);
        if (!item) {
          return <div key={`${code}-${index}`} title={code}><span className="raid-practice-nikke-empty">{code}</span></div>;
        }
        const burst = burstRoman(item);
        return (
          <div key={`${code}-${index}`} title={item.name || code}>
            <span className="raid-practice-nikke-art">
              <NikkePortraitImage
                src={item.imageUrl}
                alt=""
                fallbackText={item.name?.slice(0, 1) || '?'}
                fallbackClassName="raid-practice-nikke-letter"
                loading={loading}
                fetchPriority={fetchPriority}
              />
              {lightweight
                ? <span className="nikke-db-icon is-text-fallback raid-practice-nikke-burst" aria-label={`버스트 ${burst}`}><NikkeBurstGlyph text={burst} /></span>
                : <NikkeIcon
                    type="burst"
                    iconKey={item.burstCode || item.burst}
                    aliases={[item.burst, burst]}
                    label={`버스트 ${burst}`}
                    imageUrl={item.burstImageUrl}
                    fallbackText={burst}
                    className="raid-practice-nikke-burst"
                    forceText
                    scalableGlyph
                  />}
              <ElementIcon
                element={item.element}
                imageUrl={item.elementImageUrl}
                className="raid-practice-nikke-element"
              />
            </span>
            {/* Names scroll in lightweight mode too: the name box is narrower than most long names,
                and a plain span clipped them at both ends ("브리드 : 사일런트 트랙" read "드 : 사일런트"). */}
            <MarqueeText text={item.name} className="raid-practice-nikke-name" />
          </div>
        );
      })}
    </div>
  );
}
